import React  from "react";
import { connect } from "react-redux";
import TrainingCertificationTable from "./components/TrainingCertificationTable";



const TrainingCertifications = () => {
	return (

    <div>
      <div className="w-full mt-5">
          <TrainingCertificationTable />
      </div>
    </div>
      
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingCertifications);